import { render } from "./cp_ScoreShower.vue?vue&type=template&id=31a0ba7f"
import script from "./cp_ScoreShower.vue?vue&type=script&lang=js"
export * from "./cp_ScoreShower.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WorkCode\\HZY2026\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__